/**
 * The live dashboard's Get Started videos (N77) — `src/pages/GettingStarted.js`
 * on main, same videos in the same order. Embeds stay on youtube-nocookie, as
 * live has them, so nothing is set in the trader's browser until they press
 * play. Thumbnails are live's own, scaled down to 640×360 for a list that
 * draws them at a fraction of that.
 */
const embed = (id, si) => `https://www.youtube-nocookie.com/embed/${id}?si=${si}`;

export const VIDEOS = [
  {
    id: 'dashboard-overview',
    title: 'Dashboard Overview',
    length: '16:32',
    src: embed('gnv4BrgvIDk', 'j3HiCIfh8vG46ePa'),
  },
  {
    id: 'mt5-login',
    title: 'MT5 Login Overview',
    length: '10:23',
    src: embed('Wchx17KgTHY', 'F0iMVo8Sft7NqOyL'),
  },
  {
    id: 'support-and-resistance',
    title: 'Identifying Support And Resistance',
    length: '6:35',
    src: embed('8afZ-r5YZe0', 'Vc90Xu666TgtYWJ4'),
  },
  {
    id: 'financial-markets',
    title: 'How do the Financial Markets Work',
    length: '10:51',
    src: embed('V4Vm9r2tqYY', 'vf2VeirHYHsMBVpm'),
  },
  {
    id: 'identifying-trends',
    title: 'Identifying Trends on your charts',
    length: '10:51',
    src: embed('HwHPtEerCq8', 'CHHLyjEv27H8G085'),
  },
].map((video) => ({ ...video, thumb: `/images/tutorials/${video.id}.jpg` }));
